module.exports = __webpack_public_path__ + "img/heroBanner.7dc878ae.webp";